import { BaptizeAmericaServiceException as __BaseException } from "./BaptizeAmericaServiceException";
export class InternalServerError extends __BaseException {
    name = "InternalServerError";
    $fault = "server";
    stackTrace;
    constructor(opts) {
        super({
            name: "InternalServerError",
            $fault: "server",
            ...opts,
        });
        Object.setPrototypeOf(this, InternalServerError.prototype);
        this.stackTrace = opts.stackTrace;
    }
}
export class ValidationError extends __BaseException {
    name = "ValidationError";
    $fault = "client";
    errorMessage;
    constructor(opts) {
        super({
            name: "ValidationError",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ValidationError.prototype);
        this.errorMessage = opts.errorMessage;
    }
}
